import React from 'react';
import useTheme from 'src/hooks/useTheme';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view';
import CorporateColors from 'src/misc/CorporateColors';

const EventViewer = ({ eventId, eventDetail, onClose }) => {
  const { isDarkMode } = useTheme();

  return (
    <Modal
      width={1200}
      open={true}
      title={`Event ID: ${eventId}`}
      onCancel={() => {
        onClose();
      }}
      footer={null}
    >
      <ReactJson style={{ padding: '12px', border: `1px solid ${CorporateColors.aqua}`, borderRadius: '0.25rem', fontSize: '0.7rem' }} src={eventDetail ?? {}} theme={isDarkMode ? 'shapeshifter' : 'shapeshifter:inverted'} iconStyle='square' enableClipboard='false' enableAdd={false} enableEdit={false} enableDelete={false} displayDataTypes={false} displayObjectSize={false} />
    </Modal>
  );
};

EventViewer.propTypes = {
  eventId: PropTypes.string,
  eventDetail: PropTypes.object,
  onClose: PropTypes.func,
};

export default EventViewer;
